import { render } from "./guestForm.vue?vue&type=template&id=126ffbec&scoped=true"
import script from "./guestForm.vue?vue&type=script&lang=js"
export * from "./guestForm.vue?vue&type=script&lang=js"

import "./guestForm.vue?vue&type=style&index=0&id=126ffbec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126ffbec"]])

export default __exports__